<div class="exam-question-view" appBlockCopyPaste>
  <app-candidate-header></app-candidate-header>

  <div class="exam-container">
    <!-- Assessment Info Header -->
    <app-assessment-info-card [assessmentInfo]="assessmentInfo"></app-assessment-info-card>

    <!-- Main Content Area -->
    <div class="exam-content">
      <!-- Question Section -->
      <div class="question-panel">
        <div *ngIf="questionView else questionsSubmitView" class="question-content">
          <!-- Question Header -->
          <div class="question-header">
            <div class="question-number">
              <mat-icon>quiz</mat-icon>
              Question {{assessmentData?.currentQuestion}} of {{assessmentData?.totalquestions}}
            </div>
          </div>

          <!-- Question Body -->
          <div class="question-body">
            <ng-container *ngIf="assessmentData?.question?.questionText">
              <div class="question-text" [innerHTML]="formatQuestionText(assessmentData.question.questionText)"></div>
            </ng-container>

            <!-- Answer Section -->
            <div class="answer-section">
              <!-- Multiple Choice -->
              <mat-radio-group [(ngModel)]="selectedOption" class="mcq-options"
                *ngIf="assessmentData?.question?.questionType === 'MULTIPLE_CHOICE'">
                <mat-radio-button color="primary" class="mcq-option"
                  *ngFor="let option of assessmentData?.question?.options; let i = index" [value]="option"
                  (change)="selectAnswerOption($event)">
                  <div class="option-content">
                    <span class="option-label">{{String.fromCharCode(65 + i)}}</span>
                    <div [innerHTML]="formatQuestionText(option)" class="option-text"></div>
                  </div>
                </mat-radio-button>
              </mat-radio-group>

              <!-- Open Ended -->
              <div class="open-ended-section" *ngIf="assessmentData?.question?.questionType === 'OPEN_ENDED'">
                <label class="answer-label">Your Answer:</label>
                <angular-editor class="open-ended-editor" [(ngModel)]="assessmentData.question.answer"
                  (ngModelChange)="onOeqChanged($event)" [config]="openEndedConfig">
                </angular-editor>
              </div>

              <!-- Coding Question -->
              <div class="coding-section" *ngIf="assessmentData?.question?.questionType === 'CODING'">
                <div class="coding-prompt">
                  <mat-icon>code</mat-icon>
                  <span>Ready to start coding?</span>
                </div>
                <button mat-raised-button color="primary" class="code-editor-btn" (click)="openCodingEditor()">
                  <mat-icon>launch</mat-icon>
                  Open Code Editor
                </button>
              </div>
            </div>
          </div>

          <!-- Navigation -->
          <div class="question-navigation">
            <button mat-raised-button [disabled]="assessmentData?.currentQuestion === 1" class="nav-btn prev-btn"
              (click)="previousQuestion(assessmentData)" *ngIf="assessmentData?.totalquestions > 1">
              <mat-icon>arrow_back</mat-icon>
              Previous
            </button>

            <button mat-raised-button color="primary" class="nav-btn next-btn" (click)="nextQuestionHandler()"
              [disabled]="questionType === 'CODING' && assessmentData?.currentQuestion === assessmentData?.totalquestions">
              Next
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>

          <!-- Submit Button (when all viewed) -->
          <div class="submit-section" *ngIf="questionView && (totalQuestions === assessmentData?.viewedtill?.length)">
            <button mat-raised-button color="primary" class="submit-btn" (click)="submitAnswers(assessmentData)"
              [disabled]="submitted || (assessmentData?.viewedtill?.length !== totalQuestions)">
              <mat-icon>check_circle</mat-icon>
              Submit All Answers
            </button>
          </div>
        </div>

        <!-- Submit View Template -->
        <ng-template #questionsSubmitView>
          <div class="submit-view">
            <div class="submit-icon">
              <mat-icon>task_alt</mat-icon>
            </div>
            <h2>
              {{ (totalModules === 1) ? 'Ready to submit your assessment?' : 'Ready to submit this section?' }}
            </h2>
            <p class="submit-summary">
              You have answered <strong>{{answeredQuestions}}</strong>
              {{answeredQuestions > 1 ? 'questions' : 'question'}} out of
              <strong>{{totalQuestions}}</strong> total questions.
            </p>
            <p class="submit-note">
              Once you submit, you won't be able to make changes. HR will contact you with the results.
            </p>
            <button mat-raised-button color="primary" class="final-submit-btn" (click)="submitAnswers()"
              [disabled]="submitted || (assessmentData?.viewedtill?.length !== totalQuestions)">
              <mat-icon>send</mat-icon>
              {{ (totalModules === 1) ? 'Submit Assessment' : ('Submit ' + questionTypes[questionType] + ' section') }}
            </button>
          </div>
        </ng-template>
      </div>

      <!-- Sidebar -->
      <div class="exam-sidebar">
        <!-- Timer Card -->
        <div class="timer-card" *ngIf="currentModuleType !== 'CODING'">
          <div class="timer-header">
            <mat-icon>schedule</mat-icon>
            <span>Time Remaining</span>
          </div>
          <div class="timer-display" *ngIf="assessmentData?.remainingModuleTime">
            <countdown #cd [config]="{
                leftTime: assessmentData?.remainingModuleTime, 
                format: 'HH:mm:ss', 
                notify: [120]
              }" class="countdown-timer" (event)="handleEvent($event)"></countdown>
          </div>
        </div>

        <!-- Question Navigator -->
        <div class="question-navigator">
          <div class="navigator-header">
            <mat-icon>view_list</mat-icon>
            <span>Question Navigator</span>
          </div>
          <div class="question-grid">
            <button *ngFor="let obj of questionNumbers; let i = index;" class="question-btn" [ngClass]="{
                      'answered': obj.viewed && !obj.skipped,
                      'skipped': obj.skipped,
                      'current': (i+1) === assessmentData?.currentQuestion,
                      'unanswered': !obj.viewed
                    }" (click)="questionNumberClick(obj.questionNumber)" [disabled]="submitted || !obj.viewed">
              {{obj.questionNumber}}
            </button>
          </div>

          <!-- Legend -->
          <div class="legend">
            <div class="legend-item">
              <div class="legend-indicator answered"></div>
              <span>Answered</span>
            </div>
            <div class="legend-item">
              <div class="legend-indicator current"></div>
              <span>Current</span>
            </div>
            <div class="legend-item">
              <div class="legend-indicator skipped"></div>
              <span>Skipped</span>
            </div>
            <div class="legend-item">
              <div class="legend-indicator unanswered"></div>
              <span>Not Visited</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>